const PENDING_APPOINTMENT_KEY = "hmsPendingAppointment";
const BOUND_PATIENT_PREFIX = "hmsBoundPatientId:";
const BOOKING_ORG_KEY = "hmsBookingOrganizationId";

const digits10 = (value) => String(value || "").replace(/\D/g, "").slice(-10);

export const normalizeOrganizationId = (value) => {
  if (value == null || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const savePendingAppointment = (payload) => {
  try {
    const pendingPayload = {
      ...payload,
      createdAt: Number(payload?.createdAt) || Date.now(),
    };
    sessionStorage.setItem(PENDING_APPOINTMENT_KEY, JSON.stringify(pendingPayload));
    const organizationId = normalizeOrganizationId(payload?.organizationId);
    if (organizationId) {
      sessionStorage.setItem(BOOKING_ORG_KEY, String(organizationId));
    }
  } catch (error) {
    console.warn("Unable to save pending appointment:", error);
  }
};

export const readPendingAppointment = () => {
  try {
    const raw = sessionStorage.getItem(PENDING_APPOINTMENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const clearPendingAppointment = () => {
  sessionStorage.removeItem(PENDING_APPOINTMENT_KEY);
};

export const setBookingOrganizationId = (organizationId) => {
  const orgId = normalizeOrganizationId(organizationId);
  if (!orgId) return;
  try {
    sessionStorage.setItem(BOOKING_ORG_KEY, String(orgId));
  } catch (error) {
    console.warn("Unable to save booking organization:", error);
  }
};

export const getBookingOrganizationId = () => {
  return normalizeOrganizationId(
    sessionStorage.getItem(BOOKING_ORG_KEY) ||
      readPendingAppointment()?.organizationId
  );
};

export const clearBookingOrganizationId = () => {
  sessionStorage.removeItem(BOOKING_ORG_KEY);
};

export const applyPatientBookingOrganization = (user, organizationId) => {
  const orgId = normalizeOrganizationId(organizationId);
  if (!user?.id || !orgId) return user;

  const updatedUser = { ...user, organizationId: orgId };
  localStorage.setItem("user", JSON.stringify(updatedUser));
  localStorage.setItem("organizationId", String(orgId));
  window.dispatchEvent(
    new CustomEvent("userOrganizationIdUpdated", {
      detail: { updatedUser },
    })
  );
  return updatedUser;
};

export const bindPatientToUser = (userId, patientId) => {
  if (userId == null || patientId == null || patientId === "") return;
  localStorage.setItem(`${BOUND_PATIENT_PREFIX}${userId}`, String(patientId));
};

export const getBoundPatientId = (userId) => {
  if (userId == null) return null;
  return localStorage.getItem(`${BOUND_PATIENT_PREFIX}${userId}`);
};

export const patientRecordMatchesUser = (patient, userId, mobile) => {
  if (!patient?.id || userId == null) return false;

  const recordUserId = patient.userId ?? patient.user_id;
  if (recordUserId != null && String(recordUserId) !== String(userId)) {
    return false;
  }

  const wantedMobile = digits10(mobile);
  const recordMobile = digits10(patient.mobile || patient.contactNumber);

  if (wantedMobile && recordMobile && recordMobile !== wantedMobile) {
    return false;
  }

  if (recordUserId == null) {
    return Boolean(wantedMobile && recordMobile === wantedMobile);
  }

  return true;
};
